import ArrowTooltips from './View/ToolTips.view';
export default ArrowTooltips;
